import { Icon } from '@lightspeed/design-system-react'
import { UT } from '@transifex/react'
import React, { FunctionComponent } from 'react'
import { useRegisterManager } from '../../../ng-compat/hooks'

export const getFSPaymentsSettingsUrl = (outletId: string): string =>
  `/lightspeed-payments/reports/settings/${encodeURIComponent(
    `lsx:${outletId}`
  )}/payments`

/**
 * Banner shown when the outlet still uses legacy cash discounting and has not
 * configured the LSPay cash discount rate.
 */
export const CashDiscountingMigrationBanner: FunctionComponent = () => {
  const outletId = useRegisterManager().getActiveOutlet()?.id ?? ''
  const fsPaymentsSettingsUrl = getFSPaymentsSettingsUrl(outletId)

  return (
    // Can't use helios <Banner> because it justifies all the text to the centre
    <div className="wr-lsp-cash-discounting-banner vd-banner vd-banner--negative">
      <div className="vd-banner-wrapper vd-flex vd-flex--justify-between">
        <span>
          <Icon
            icon="fa-exclamation-triangle"
            className="vd-banner-icon"
          ></Icon>
          <UT
            _inline
            _str={`On Oct 1, 2026, the current Cash Discounting feature will be replaced by the new version available through Lightspeed Payments. To avoid interruptions, set it up again in <a class="vd-link" href="${fsPaymentsSettingsUrl}">Financial Services</a>.`}
            _context="Cash discounting migration banner"
          />
        </span>
      </div>
    </div>
  )
}
